export const SET_TRANSACTION_STATISTIC = 'SET_TRANSACTION_STATISTIC';
export const SET_ACCOUNT_STATISTIC = 'SET_ACCOUNT_STATISTIC';
export const SET_CAPTCHA_SOLVED_STATISTIC = 'SET_CAPTCHA_SOLVED_STATISTIC';